import { connect } from "react-redux";

import type { VehicleType } from "@busbud/int-schemas/lib/vehicles";
import type { MappedOperator, TicketType } from "@busbud/int-schemas/udm";

import { orderTicketTypesByRanking } from "@app/helpers/udm/ticket-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { TripOption } from "@app/types/results-types";

import type { ConnectedProps } from "react-redux";

import { FaresList as FaresListComponent } from "./fares-list";
import { isRoundtrip } from "../../../helpers/search";
import {
  getFromOptionsMatriceFirstCoordinateForATripId,
  getLegCardOptionsMatrixForJourney
} from "../../results/selectors/leg-cards/get-options";
import { getSearchedLegSegments } from "../../results/selectors/trips/get-segments";
import { getSearchedLegOperators } from "../../results/selectors/trips/get-trip-operators";

interface StateProps {
  operator?: MappedOperator;
  ticket_type?: TicketType | null;
  vehicle_type?: VehicleType;
  trip_type?: string;
  fares?: TripOption[];
}

interface OwnProps {
  leg_card_id?: string | null;
  selected_trip_id?: string;
  journey_id: string | null;
}

const mapStateToProps = (
  state: ResultsReduxState,
  ownProps: OwnProps
): StateProps => {
  const { leg_card_id, selected_trip_id, journey_id } = ownProps;

  if (!leg_card_id) {
    return {};
  }

  const trip_options_matrix = getLegCardOptionsMatrixForJourney(
    state,
    leg_card_id,
    journey_id
  );

  if (selected_trip_id) {
    const trip_segments = getSearchedLegSegments(state, selected_trip_id);
    const operators = getSearchedLegOperators(state, selected_trip_id);
    // @ts-expect-error TS2339 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const { ticket_types, operator_id, vehicle } = trip_segments[0];

    const [matrix_row_class_index] =
      getFromOptionsMatriceFirstCoordinateForATripId(
        trip_options_matrix,
        selected_trip_id
      );

    const fares =
      // TODO: UDMV4 this will be remove when we flatten option
      matrix_row_class_index !== undefined
        ? trip_options_matrix[matrix_row_class_index]
        : [];

    return {
      fares,
      ticket_type: orderTicketTypesByRanking(ticket_types)[0],
      operator: operators.find(operator => operator.id === operator_id),
      vehicle_type: vehicle?.type,
      trip_type: isRoundtrip(state.search) ? "roundtrip" : "one-way"
    };
  }

  return {};
};

const connector = connect(mapStateToProps);

export type ConnectorProps = ConnectedProps<typeof connector>;

export const FaresList = connector(FaresListComponent);
